/**
 * Normalises a phone number as typed ("(604) 555-0100", "604.555.0100", "+1 604 555 0100") to
 * E.164. Ten-digit numbers are taken as North American (+1) unless another calling code is given.
 * Returns null when it cannot be a phone number. A +1 (North American) number has exactly ten digits
 * after the 1, and neither its area code nor its exchange starts with 0 or 1 (QA-191). This is the
 * fast first pass, cheap enough for the browser; the server also checks the number is a real one
 * (validPhone in the modules, with libphonenumber's metadata).
 */
export function normalizePhone(input: string, defaultCallingCode = '1'): string | null {
  const trimmed = input.trim();
  const digits = trimmed.replace(/\D/g, '');
  const e164 = (d: string) => (d.startsWith('1') && !NANP.test(d) ? null : `+${d}`);
  if (trimmed.startsWith('+'))
    return digits.length >= 7 && digits.length <= 15 && digits[0] !== '0' ? e164(digits) : null;
  if (digits.length === 10 && defaultCallingCode === '1') return e164(`1${digits}`);
  if (digits.length === 11 && digits.startsWith('1')) return e164(digits);
  if (digits.startsWith('00') && digits.length > 9) return e164(digits.slice(2));
  return null;
}

/** 1, then a ten-digit North American number: area code and exchange each start with 2 to 9. */
const NANP = /^1[2-9]\d{2}[2-9]\d{6}$/;
